// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.competition-settings[data-v-f25a1330] {\n  width: 100%;\n}\n@media (min-width: 992px) {\n.competition-settings[data-v-f25a1330] {\n    margin-left: 30px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
